import { Spacer, SpacerSize, Sticker, Text, TextLevels, TypographyBold, VariantState } from '@bytel/trilogy-react';

import { formatPrice } from '@helpers/wording';

export function OdrInfos({
    odrRefund,
    phonePriceWithOdrDeducted,
}: {
    odrRefund: number;
    phonePriceWithOdrDeducted: number;
}) {
    return (
        <>
            <Spacer size={SpacerSize.TWO} />
            <Sticker variant={VariantState.ACCENT} small label={`${formatPrice(odrRefund)} remboursés après achat`} />

            <Text typo={TypographyBold.TEXT_WEIGHT_SEMIBOLD} level={TextLevels.TWO}>
                Vous bénéficiez de ce prix de {formatPrice(phonePriceWithOdrDeducted)} grâce aux{' '}
                {formatPrice(odrRefund)} remboursés sur demande&nbsp;!
            </Text>
            <Text marginless level={TextLevels.TWO}>
                On vous envoie les instructions par email juste après votre achat.
            </Text>
        </>
    );
}
